export default __webpack_public_path__ + "static/media/no_pass_bg.c532761b.png";